import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createRef, useContext, useState, memo } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import Asset from './Asset';
import css from './Assets.module.scss';
import HorizontalSnapper from '../../../components/HorizontalSnapper';
import LightBox from '../LightBox';
import TextAsset from './TextAsset';
import { OVContext } from '../../../utils/OVContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Wrap = function Wrap(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick;

  if (typeof onClick === 'function') {
    return /*#__PURE__*/_jsx("button", {
      "aria-label": ariaLabel,
      className: className,
      onClick: onClick,
      children: children
    });
  }

  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: children
  });
};

Wrap.defaultProps = {
  ariaLabel: '',
  className: '',
  onClick: false
};
Wrap.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
};

var Assets = function Assets(_ref2) {
  var assets = _ref2.assets,
      textAssetsOnly = _ref2.textAssetsOnly,
      description = _ref2.description,
      subtitle = _ref2.subtitle,
      title = _ref2.title;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      lightBox = _useState2[0],
      setLightBox = _useState2[1];

  var _useContext = useContext(OVContext),
      mobileMedium = _useContext.mobileMedium;

  var fullWidthAssets = [];
  var textAssets = [];
  var lightBoxAssets = [];
  var snapperAssets = [];
  var thumbnails = [];
  var showLightBox = typeof lightBox === 'number';
  var singleImage = assets.length === 1;

  var subtitleLightBox = /*#__PURE__*/_jsx("h3", {
    className: css.subtitleLightBox,
    children: subtitle
  });

  assets.map(function (asset, index) {
    var assetId = asset.id,
        fullWidth = asset.fullWidth,
        isTechnicalDetail = asset.isTechnicalDetail,
        isTextAsset = asset.isTextAsset,
        image = asset.image,
        video = asset.video;
    if (isTechnicalDetail) return;
    var assetClass = cc([css.asset, _defineProperty({}, css.textAsset, isTextAsset), _defineProperty({}, css.fullWidth, fullWidth && !isTextAsset)]);
    var ariaLabel = "Click to expand a modal with a detailed view of the ".concat(video ? 'video' : 'image', ".");
    /* eslint-disable */

    var child = !isTextAsset ? /*#__PURE__*/_jsx(Asset, _objectSpread(_objectSpread({}, asset), {}, {
      lazyload: index > 2
    })) : /*#__PURE__*/_jsx(TextAsset, _objectSpread(_objectSpread({}, asset), {}, {
      image: image,
      imageLeft: lightBoxAssets.length % 2 === 0,
      fullWidth: fullWidth,
      title: title
    }));
    /* eslint-enable */

    lightBoxAssets.push( /*#__PURE__*/_jsx(Wrap, {
      ariaLabel: ariaLabel,
      className: assetClass,
      onClick: function onClick(event) {
        event.stopPropagation();
        setLightBox(index);
      },
      children: child
    }, "desktop-".concat(assetId)));

    if (fullWidth) {
      fullWidthAssets.push(child);
    } else if (isTextAsset) {
      textAssets.push(child);
    } else if (!fullWidth || assets.length === 1) {
      snapperAssets.push(_objectSpread(_objectSpread({}, asset), {}, {
        content: /*#__PURE__*/_jsx(Wrap, {
          className: assetClass,
          children: child
        }, "desktop-".concat(assetId))
      }));
      {
        asset.image && thumbnails.push(_objectSpread({}, asset.image));
      }
    }
  });

  if (textAssetsOnly) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [textAssets, fullWidthAssets.length !== 0 && /*#__PURE__*/_jsx("div", {
        className: css.fullWidthAssets,
        children: fullWidthAssets
      })]
    });
  }

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [!mobileMedium && /*#__PURE__*/_jsxs("div", {
      className: cc([css.assets, _defineProperty({}, css.singleImage, singleImage)]),
      children: [showLightBox && /*#__PURE__*/_jsx(LightBox, {
        description: description,
        hide: function hide() {
          return setLightBox(false);
        },
        images: assets,
        initialIndex: showLightBox ? lightBox : 0,
        show: showLightBox,
        subtitle: subtitleLightBox,
        title: title
      }), lightBoxAssets]
    }), mobileMedium && /*#__PURE__*/_jsx("div", {
      className: cc([css.assets, css.mobile]),
      children: /*#__PURE__*/_jsx(HorizontalSnapper, {
        addSpacing: true,
        className: css.snapper,
        iconOnlyButtons: true,
        slides: snapperAssets,
        thumbnails: thumbnails
      })
    })]
  });
};

Assets.defaultProps = {
  textAssetsOnly: false,
  description: '',
  title: '',
  subtitle: ''
};
Assets.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool
  })).isRequired,
  textAssetsOnly: PropTypes.bool,
  description: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  title: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};
export default /*#__PURE__*/memo(Assets);